import { AxiosResponse } from 'axios';
import {
  IBillReportFilters,
  IBillReportResponse,
  IGetReportShuttlesRequest,
  IGetReportUniqueDriversRequest,
  IReportShuttlesResponse,
  IReportUniqueDriversResponse,
  IReportVehicleTripsRequest,
  IReportVehicleTripsResponse,
} from 'models/http/reports';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { prepareQPFromFilters, serverAxios } from 'utils/http';

class ReportsHttp {
  public static Route = 'reports';
  public static BillReporDataExportRoute = `${ReportsHttp.Route}/data-export/bill-report`;
  public static VehicleReportDataExportRoute = `${ReportsHttp.Route}/data-export/vehicle-report`;

  public async shuttles(request: IGetReportShuttlesRequest, abortController?: AbortController): Promise<IReportShuttlesResponse> {
    const query = prepareQPFromFilters(request).toString();

    return serverAxios
      .get(`/${ReportsHttp.Route}/shuttles?${query}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IReportShuttlesResponse>) => {
        return response.data;
      });
  }

  public async uniqueDrivers(
    request: IGetReportUniqueDriversRequest,
    abortController?: AbortController,
  ): Promise<IReportUniqueDriversResponse> {
    const query = prepareQPFromFilters(request).toString();

    return serverAxios
      .get(`/${ReportsHttp.Route}/uniqueDrivers?${query}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IReportUniqueDriversResponse>) => {
        return response.data;
      });
  }

  public async vehicleTrips(request: IReportVehicleTripsRequest, abortController?: AbortController): Promise<IReportVehicleTripsResponse> {
    const query = prepareQPFromFilters(request).toString();

    return serverAxios
      .get(`/${ReportsHttp.Route}/vehicleTrips?${query}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IReportVehicleTripsResponse>) => {
        return response.data;
      });
  }

  public async bill(request: IBillReportFilters, abortController?: AbortController): Promise<IBillReportResponse> {
    const query = prepareQPFromFilters(request).toString();

    return serverAxios
      .get(`/${ReportsHttp.Route}/bill?${query}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IBillReportResponse>) => {
        return response.data;
      });
  }
}

export default ReportsHttp;
